import {
  Navigate,
  Route,
  Routes as RouterRoutes,
  useParams,
} from "react-router-dom"

import Contatti from "./components/Contatti"
import Esperienze from "./components/esperienze/Esperienze"
import EsperienzeIndex from "./components/esperienze/EsperienzeIndex"
import Home from "./components/Home"
import LaSocieta from "./components/chi-siamo/LaSocieta"
import NotFound from "./components/NotFound"
import Partner from "./components/chi-siamo/Partner"
import Progetti from "./components/servizi/Progetti"
import React from "react"
import RilieviGeoDrone from "./components/servizi/RilieviGeoDrone"
import RilieviIdro from "./components/servizi/RilieviIdro"
import ServiziFormazione from "./components/servizi/ServiziFormazione"
import Studi from "./components/servizi/Studi"
import SubEsperienze from "./components/esperienze/SubEsperienze"
import Team from "./components/chi-siamo/Team"
import seedEsperienze from "./data/seedEsperienze"
import seedSubEsperienze from "./data/seedSubEsperienze"

// Wrapper components to handle params
const EsperienzeWrapper = (props) => {
  const { espId } = useParams()
  const currentEsp = seedEsperienze.find(
    (esp) => esp.id.toLowerCase() === espId.toLowerCase()
  )

  if (currentEsp) return <Esperienze {...props} esp={currentEsp} />
  else return <Navigate to="/404" />
}

const SubEsperienzeWrapper = (props) => {
  const { subEspId } = useParams()
  const currentSubEsp = seedSubEsperienze.find(
    (subEsp) => subEsp.id.toLowerCase() === subEspId.toLowerCase()
  )

  if (currentSubEsp) return <SubEsperienze {...props} subEsp={currentSubEsp} />
  else return <Navigate to="/404" />
}

const Routes = (props) => {
  return (
    <RouterRoutes>
      <Route path="/" element={<Home />} />
      <Route path="/chi-siamo/la-societa" element={<LaSocieta />} />
      <Route path="/chi-siamo/il-team" element={<Team />} />
      <Route path="/chi-siamo/partner" element={<Partner />} />
      <Route path="/servizi/progetti" element={<Progetti />} />
      <Route path="/servizi/studi" element={<Studi />} />
      <Route path="/servizi/rilievi-geo-drone" element={<RilieviGeoDrone />} />
      <Route
        path="/servizi/rilievi-idro-ambientali"
        element={<RilieviIdro />}
      />
      <Route path="/servizi/formazione" element={<ServiziFormazione />} />
      <Route path="/esperienze" element={<EsperienzeIndex />} />
      <Route
        path="/esperienze/:espId"
        element={<EsperienzeWrapper {...props} />}
      />
      <Route
        path="/esperienze/:espId/:subEspId"
        element={<SubEsperienzeWrapper {...props} />}
      />
      <Route path="/contatti" element={<Contatti />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  )
}

export default Routes
